module.exports = __webpack_public_path__ + "img/ogp_movies_big.be1139c3.jpg";